export default __webpack_public_path__ + "static/media/islavalles1.041d64c7.jpg";